export default __webpack_public_path__ + "static/media/4.7585e22f.jpg";